import { ConfigService, StorageService } from '@venecia/services';
import { GlobalConstants } from '@venecia/constants';
import { FlowToken } from '@venecia/apis/auth';

export function buildAuthReturnUrl(storageService: StorageService, configService: ConfigService): string {
    const authParams = storageService.get<Record<string, string>>(GlobalConstants.AUTH_PARAMS) ?? {};
    storageService.remove(GlobalConstants.AUTH_PARAMS);

    if (Object.keys(authParams).length > 0) {
        const baseUrl = `${configService.get('http.rest.auth.url')}/api/oauth/authorize`;
        return `${baseUrl}?${toQueryString(authParams)}`;
    }

    const flowToken = storageService.get<FlowToken>(GlobalConstants.FLOW_BEARER_KEY);
    if (flowToken?.['redirect-to']) {
        storageService.remove(GlobalConstants.FLOW_BEARER_KEY);
        storageService.remove(GlobalConstants.FLOW_CODE);
        return flowToken['redirect-to'];
    }

    return configService.get('identity.url');
}

function toQueryString(params: Record<string, string>): string {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        searchParams.set(key, value);
    });

    return searchParams.toString();
}
